module.exports = __webpack_public_path__ + "static/media/iPhone.0595ba27.svg";